import { render, staticRenderFns } from "./HorseSexe.vue?vue&type=template&id=658b240e&"
import script from "./HorseSexe.vue?vue&type=script&lang=js&"
export * from "./HorseSexe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports